angular.module('igs.identity', ['igs.apiClientService'])
    .factory('igs.identityNodeAdapter', [
        function() {
            'use strict';
            var service = {};
            var site = (window.location.href.indexOf("localhost") > 0 || window.location.href.indexOf("bs-local.com") > 0) ? '/igs.solar.web' : '';

            service.mapNodes = function(nodes) {
                _.each(nodes, function(item) {
                    if (site) {
                        item.Url = site + item.Url;
                    }
                    if (item.Nodes && item.Nodes.length > 0) {
                        service.mapNodes(item.Nodes);
                    }
                });
            };

            return service;
        }
    ])
    .factory('igs.identityStateService', [
        '$q',
        function($q) {
            'use strict';
            var service = {},
                promise = $q.defer(),
                shouldShowMenuBar = true,
                hideMenuPriority = 0,
                menuHeight;    

            service.setUserAuthenticated = function(data) {
                if (data) {
                    promise.resolve(data);
                } else {
                    promise.reject();
                }
            };

            service.onUserLoaded = function() {
                return promise.promise;
            };

            service.hideMenuBar = function(priority) {
                if (hideMenuPriority < priority) {
                    hideMenuPriority = priority || 0;
                }

                shouldShowMenuBar = false;
            };

            service.showMenuBar = function(priority) {
                if ((priority || 0) >= hideMenuPriority) {
                    hideMenuPriority = 0;
                    shouldShowMenuBar = true;
                }
            };


            service.shouldShowMenuBar = function () {
                
                return shouldShowMenuBar;
            };

            service.setMenuHeight = function(height) {
                menuHeight = height;
            };

            service.getMenuHeight = function() {
                return menuHeight;
            };

            return service;
        }
    ])
    .factory('igs.identityService', [
        '$rootScope',
        '$timeout',
        '$q',
        '$window',
        'igs.apiClientService',
        'igs.identityStateService',
        'igs.identityNodeAdapter',
        '$location',
        function($rootScope, $timeout, $q, $window, client, identityStateService, nodeAdapter, $location) {
            'use strict';
            var service = {},
                defaultUrl = null;

            var site = (window.location.href.indexOf("localhost") > 0 || window.location.href.indexOf("bs-local.com") > 0) ? '/igs.solar.web' : '';
            var queryStringParamaters = $location.search();
            var siteToReturnTo = decodeURIComponent(queryStringParamaters.returnUrl);

            // decodeUriComponent(undefined) will return 'undefined' -- no idea why that would be desired
            if (siteToReturnTo === 'undefined') {
                siteToReturnTo = undefined;
            }

            service.getUserSettings = function() {
                return client.getUnsecure(site + '/api/identity/sitemap').then(function(data) {
                    if (!data || !data.User) {
                        identityStateService.setUserAuthenticated();
                        defaultUrl = site || '/';
                        return {
                            User: null,
                            DefaultUrl: site || '/',
                            Nodes: null
                        };
                    } else {
                        defaultUrl = site + data.DefaultUrl || '/';
                        data.DefaultUrl = defaultUrl;
                        nodeAdapter.mapNodes(data.Nodes); // only here because this is not root site on dev machines
                        identityStateService.setUserAuthenticated(data);
                        return data;
                    }
                }, function() {
                    identityStateService.setUserAuthenticated();
                });
            };

            service.isEmailAddressValid = function(emailAddress) {
                if (!_.isString(emailAddress) ||
                    emailAddress.length < 3 ||
                    emailAddress.length > 254) {
                    return false;
                }
                // Same validation Google Closure Library uses:
                // http://docs.closure-library.googlecode.com/git/closure_goog_format_emailaddress.js.source.html
                var regex = /^[+a-zA-Z0-9_.!#$%&'*\/=?^`{|}~-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z0-9]{2,6}$/;
                return regex.test(emailAddress);
            };

            service.isUsernameValid = function(username) {
                return !(!_.isString(username) ||
                    username < 1 ||
                    username > 254);

            };

            service.isUserInRole = function(roleName) {
                return client.get(site + '/api/identity/isInRole/' + roleName, { cache: true})
                    .then(function(result) {
                        return result === true || result === "true";
                    });
            };

            service.getWindowsUsername = function() {
                return client.getUnsecure(site + '/api/identity/windows/username', { cache: true });
            }

            service.isPasswordValid = function(password) {
                return !(!_.isString(password) ||
                    password.length < 1 ||
                    password.length > 120);

            };

            service.getCurrentUser = function() {
                return client.getUnsecure(site + '/api/identity/currentUser').then(function (data) {
                    if (data && data !== 'null') {
                        var site = (window.location.href.indexOf("localhost") > 0 || window.location.href.indexOf("bs-local.com") > 0) ? '/igs.solar.web' : '';
                        defaultUrl = site + data.DefaultPageUrl;
                        return data;
                    } else
                        defaultUrl = undefined;

                    return null;
                });
            };

            service.login = function(username, password) {
                var request = {
                    Username: username,
                    Password: password
                };
                return client.postUnsecure(site + '/api/identity/login', request).then(function(data) {
                    if (data.IsSuccessful) {
                            if (siteToReturnTo) {
                                $window.location.href = siteToReturnTo;
                            }
                    } else {
                            $window.location.href = site + '/#/login';
                            if (siteToReturnTo) {
                                $window.location.href += '?returnUrl=' + siteToReturnTo;
                            }
                    }
                    return data;
                });
            };

            service.goToLoginPage = function () {
                $window.location.href = site + '/#/login';
            };

            service.logout = function () {
                identityStateService.setUserAuthenticated();
                return client.getUnsecure(site + '/api/authentication/logout').then(function () {
                    service.goToLoginPage();
                });
            };

            service.resetPassword = function(username) {
                return client.postUnsecure(site + '/api/identity/resetpassword', { Username: username }).then(function(data) {
                    return data;
                });
            };

            service.goToDefaultPage = function () {
                if (defaultUrl) {
                     $window.location.href = defaultUrl;
                }
            };

            return service;
        }
    ])    
    .directive('igsIdentityMenu', [
        '$rootScope',
        '$document',
        '$window',
        'igs.identityService',
        'igs.identityStateService',
        function($rootScope, $document, $window, identityService, identityStateService) {
            'use strict';
            return {
                restrict: 'A',
                scope: {
                    rootUrl: '=root'
                },
                template: "<header class=\"navbar navbar-fixed-top igs-menu-nav environmentColor\" id=\"top\" role=\"navigation\" ng-if=\"shouldShowMenuBar()\">" +
                    "    <div class=\"container-fluid\">" +
                    "        <div class=\"navbar-header\">" +
                    "            <button class=\"navbar-toggle\" type=\"button\" data-toggle=\"collapse\" data-target=\".x-navbar-collapse\">" +
                    "                <span class=\"sr-only\">Toggle navigation<\/span>" +
                    "                <span class=\"icon-bar\"><\/span>" +
                    "                <span class=\"icon-bar\"><\/span>" +
                    "                <span class=\"icon-bar\"><\/span>" +
                    "            <\/button>" +
                    "            <a ng-href=\"{{ settings.DefaultUrl }}\" class=\"navbar-brand\">" +
                    "                <img ng-src=\"{{rootUrl}}common/img/Energy_Stacked_Color.png\" style=\"height: 50px;\" alt=\"IGS Energy\" \/>" +
                    "            <\/a>" +
                    "        <\/div>" +
                    "        <nav class=\"collapse navbar-collapse x-navbar-collapse\" role=\"navigation\">" +
                    "            <ul class=\"nav navbar-nav\">" +
                    "                <li ng-if=\"!isUserAuthenticated\">" +
                    "                    <a ng-href=\"{{ settings.DefaultUrl }}\">Home<\/a>" +
                    "                <\/li>" +
                    "                <li ng-hide=\"isUserAuthenticated || isUserAuthenticatedFailed\"><span class=\"navbar-text igs-menu-nav-auth-loading\">&nbsp;</span><\/li>" +
                    "                <li ng-show=\"isUserAuthenticated\" ng-class=\"{'dropdown': true}[hasChildren(parent)]\" ng-repeat=\"parent in settings.Nodes\">" +
                    "                    <a ng-show=\"!hasChildren(parent)\" ng-href=\"{{ parent.Url }}\">{{ parent.Title }}<\/a>" +
                    "                    <a ng-show=\"hasChildren(parent)\" class=\"dropdown-toggle\" data-toggle=\"dropdown\">{{parent.Title}} <span class=\"caret\"><\/span><\/a>" +
                    "                    <ul ng-show=\"hasChildren(parent)\" class=\"dropdown-menu\" role=\"menu\">" +
                    "                        <li ng-class=\"{'dropdown': true}[hasChildren(child)]\" ng-repeat=\"child in parent.Nodes\">" +
                    "                            <a ng-href=\"{{ child.Url }}\">{{ child.Title }}<\/a>" +
                    "                        <\/li>" +
                    "                    <\/ul>" +
                    "                <\/li>" +
                    "            <\/ul>" +
                    "            <ul ng-show=\"settings.User && settings.IsFormsAuthentication\" class=\"nav navbar-nav navbar-right\">" +
                    "                <li class=\"dropdown\">" +
                    "                    <a class=\"dropdown-toggle\" data-toggle=\"dropdown\" href=\"#\" title=\"{{ settings.User.UserName }}\"><i class=\"fa fa-user\"><\/i> <span class=\"caret\"><\/span><\/a>" +
                    "                    <ul class=\"dropdown-menu\" role=\"menu\">" +
                    "                        <li><a ng-href=\"{{site}}/legacy/#/changepassword\">Change Password<\/a><\/li>" +
                    "                        <li class=\"divider\"><\/li>" +
                    "                        <li><a ng-href=\"{{site}}/authentication/#/logout\">Logout {{ settings.User.UserName }}<\/a><\/li>" +
                    "                    <\/ul>" +
                    "                <\/li>" +
                    "            <\/ul>" +
                    "            <ul ng-hide=\"settings.User\" class=\"nav navbar-nav navbar-right\">" +
                    "                <li class=\"dropdown\">" +
                    "                    <a ng-href=\"{{site}}/#/login\"><strong>Login<\/strong><\/a>" +
                    "                <\/li>" +
                    "            <\/ul>" +
                    "        <\/nav>" +
                    "    <\/div>" +
                    "<\/header>",
                link: function ($scope, $elem) {                    
                    var setEnvironmentColor = function(color) {
                        $("<style type='text/css'> .environmentColor { background-color: " + color +"!important; } </style>").appendTo("head");
                    }
                    if ($window.location.hostname.indexOf('dev') >= 0) {
                        setEnvironmentColor('salmon');
                    } else if ($window.location.hostname.indexOf('crm.int.igsenergy.com') >= 0 || $window.location.hostname.indexOf('crm-forms.int.igsenergy.com') >= 0) {
                        setEnvironmentColor('tan');
                    } else if ($window.location.hostname.indexOf('crm.qa.igsenergy.com') >= 0 || $window.location.hostname.indexOf('crm-forms.qa.igsenergy.com') >= 0) {
                        setEnvironmentColor('peachpuff');
                    }

                    $scope.rootUrl = $scope.rootUrl || '../';
                    $scope.site = (window.location.href.indexOf("localhost") > 0 || window.location.href.indexOf("bs-local.com") > 0) ? '/igs.solar.web' : '';

                    function loadSettings() {
                        return identityService.getUserSettings().then(function(data) {
                            $scope.settings = data;
                        });
                    }

                    // I want this to execute every $digest
                    $rootScope.$watch(updateHeight);
                  
                    angular.element($window).bind('resize', function () {
                        try {
                            _.defer(function() {
                                $scope.$apply(updateHeight);
                            });
                        } catch (err) {
                           //ignore 
                        }
                        //If you are already in a digest, it will throw an error. Angular will not allow it to run on current 
                        //digest. This only randomly happens when not resizing.

                    });

                    function updateHeight() {
                        var menuHeight = $elem.children('.navbar').outerHeight() || 0;
                        $($document[0].body).css('padding-top', menuHeight + 10 + 'px');
                        identityStateService.setMenuHeight(menuHeight);
                        return true;
                    }

                    $scope.$on('identity-reset', function() {
                        loadSettings();
                    });

                    $scope.hasChildren = function(node) {
                        return node.Nodes && node.Nodes.length > 0;
                    };

                    $scope.shouldShowMenuBar = identityStateService.shouldShowMenuBar;

                    $scope.isUserAuthenticated = false;
                    identityStateService.onUserLoaded().then(function() {
                        $scope.isUserAuthenticated = true;
                    }, function() {
                        $scope.isUserAuthenticatedFailed = true;
                    });

                    loadSettings();
                }
            };
        }
    ])
    .controller('TopMarginController', [
        '$scope', 'igs.identityStateService',
        function($scope, identityStateService) {
            'use strict';
            $scope.getTopMargin = function() {
                return identityStateService.getMenuHeight() + 0 + 'px';
            };
        }
    ]);